import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { colours } from "utils";
import { A, CXXL, H2Rox } from "@/components/Typography";
import Device from "@/utils/device";
import Image from "next/image";
import { Space } from "../Utils";
import MarketingLink from "../marketing/MarketingLink";
import MarketingButton from "../marketing/MarketingButton";

type Props = {
  formModalOpen: () => void;
};

const EnquireContent: FunctionComponent<Props> = ({
  formModalOpen: formModalOpen,
}) => {
  return (
    <S.Section data-cy="SF-content-2023" id="enquire">
      <S.CopyContainer>
        <H2Rox>
          <S.BoldWrap>
            Enquiries:
            <br />
          </S.BoldWrap>
        </H2Rox>
        <Space height={5} />
        <MarketingLink
          animationColour={colours.marketingMango}
          href="https://calendly.com/tyra-bateman-allbright"
          linkText="Chat to the team"
          target="_blank"
        />
        <Space height={10} />
        <MarketingButton
          animationColour={colours.marketingMango}
          buttonText="Register interest"
          name="submit_button"
          type="button"
          onClick={formModalOpen}
        />
        <Space height={20} />
        <CXXL>
          <S.ItalicWrap>Contact</S.ItalicWrap>
        </CXXL>
        <A href={"mailto:allbrightmemberships@everywoman.com"}>
          allbrightmemberships@everywoman.com
        </A>
      </S.CopyContainer>
      <S.ImageContainer>
        <Image src="/images/ab-ew.png" alt="" layout="fill" objectFit="cover" />
      </S.ImageContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  position: relative;
  width: 100%;
  padding: 10% 10%;
  background: ${colours.shellOverlay};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 40px;

  @media ${Device.tablet} {
    flex-direction: row;
    padding: 5% 10%;
  }
`;

S.CopyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  > ${H2Rox} {
    font-size: 3rem;
    line-height: 3rem;
  }

  @media ${Device.tablet} {
    > ${H2Rox} {
      font-size: 4rem;
      line-height: 4rem;
    }
  }
`;

S.ImageContainer = styled.div`
  width: 50%;
  position: relative;
  overflow: hidden;
  aspect-ratio: 3/1;
  align-self: flex-end;

  @supports not (aspect-ratio: 3/1) {
    &::before {
      float: left;
      padding-top: 120%;
      content: "";
    }
    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }

  @media (${Device.tablet}) {
    width: 20%;
  }
`;

S.ItalicWrap = styled.span`
  font-style: italic;
  font-family:
    Roxborough CF,
    sans-serif;
  font-weight: 100;
`;

S.BoldWrap = styled.span`
  font-weight: 600;
`;

export default EnquireContent;
